import React, { Component }   from 'react'
import PropTypes              from 'prop-types'
import { Route, Switch }      from 'react-router-dom'
import without                from 'lodash.without'
import union                  from 'lodash.union'
import Toast                  from '../../components/Toast'
import { getMajors }          from '../../api/major'
import { TYPE_UNDERGRADUATE } from '../Major/constants'
import SchoolList                 from '../School/List/index'
import OperationBtn2           from './OperationBtn2'
import { LIMIT }              from '../constants'
import '../Major/List/index.less'
import './Choose.less';

const paramReset = {
  limit: LIMIT,
  page: 1,
  _s_type: null,
  _s_category_id: null,
  _s_classifiy_id: null,
  _s_name: null,
}

class ChooseSchoolList extends Component {

  static propTypes = {
    codes: PropTypes.array,
  onSelectChange: PropTypes.func,
  }

  state = {
    searchVal: '',
    lastPage: false,
    searchResult: [],
    param: paramReset,
    loading: false,
    showToast: false,
    toastIcon: 'success',
    toastText1: '',
    toastText2: '',
  }

  searchInput = null

  handleSearch(value) {
    const param = {
      _s_type: TYPE_UNDERGRADUATE,
      _s_name: value,
    }
    this.setState({
      searchVal: value,
      loading: Boolean(value),
    })
    if (value) {
      getMajors(param).then(res => {
        this.setState({
          searchResult: res.data,
          lastPage: res.lastPage,
        })
      }).finally(() => {
        this.setState({
          loading: false,
        })
      })
    }
  }

  handleResetSearch() {
    const { history } = this.props
    this.searchInput.reset()
    history.push(`/majorwishlist/choose`)
  }

  handleBack() {
    const { history } = this.props
    history.push(`/schoolwishlist`)
  }

  handleMajorClick(major) {
    const { history } = this.props
    history.push(`/majorwishlist/major/${major.id}`)
  }

  // renderSearchResult() {
  //   const { searchResult } = this.state
  //   if (Array.isArray(searchResult) && searchResult.length) {
  //     return (
  //       <div className="major-list-outter search-result">
  //         <div className='search-title'>搜索结果</div>
  //         {searchResult.map((d, i) =>
  //           <MajorItem
  //             key={i}
  //             major={d}
  //             // onClick={onMajorClick}
  //             rightIcon={this.renderRightIcon.bind(this)}
  //           />
  //         )}
  //         <div className="search-bottom">已加载所有结果</div>
  //       </div>
  //     )
  //   } else {
  //     return <NoResult
  //       prompt1="对不起"
  //       prompt2="没有匹配到合适的专业哦"
  //       resetBtnText="重新搜索"
  //       onResetSearch={this.handleResetSearch.bind(this)}
  //     />
  //   }
  // }

  handleModifyMajor(data, selected, e) {
      const { selectedSchoolIds,selectedSchoolList } = this.props;
      const modify = data.id;
      if(selected){
          const newIds = without(selectedSchoolIds, modify);
          const newList=selectedSchoolList.filter(i=>i.id!=modify);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'deleted' ,
                  toastText1:  '已删除' ,
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }else {
          const newIds = union(selectedSchoolIds, [modify]);
          const newList= union(selectedSchoolList,[data]);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'success',
                  toastText1: '已添加',
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }
  }

  renderRightIcon(data) {

    const { selectedSchoolIds } = this.props
    let selected = false
    if (data.id) {
      selected = selectedSchoolIds.includes(data.id)
    } else {
      // selected = data.children.every(d => selectSchoolIds.includes(d.id))
    }
    return <OperationBtn2 added={selected} onClick={this.handleModifyMajor.bind(this, data, selected)}/>
  }

  render() {
    const { match } = this.props
    const {
      searchVal,
      loading,
      showToast,
      toastIcon,
      toastText1,
      toastText2
    } = this.state
    return (
      <div className="major-list-wrapper major-wish-list-wrapper">
        <div className="major-list-outter">
            <Switch>
                <Route
                    path={`${match.url}`}
                    render={props => <SchoolList {...props} onMajorClick={this.handleMajorClick.bind(this)}
                                             rightIcon={this.renderRightIcon.bind(this)}/>}
                />

            </Switch>
        </div>
        <div className="bottom-btn">
          <button className="primary full" onClick={this.handleBack.bind(this)}>返回意向学校清单</button>
        </div>
        <Toast show={showToast} icon={toastIcon} onHide={() => this.setState({ showToast: false })}>
          <i>{toastText1}</i>
          <p>{toastText2}</p>
        </Toast>
      </div>
    )
  }
}


export default ChooseSchoolList



// WEBPACK FOOTER //
// ./src/pages/SchoolWishList/Choose.js